import { VscJson } from 'react-icons/vsc'

import JsonHighlight from '~/components/JsonHighlight'
import Panel from '~/components/Panel'
import { useAppInfo } from '~/hooks/useAppInfo'

export const AdsJSON = ({
  ads
}: {
  ads: BannerAd[] | ProductAd[] | SponsoredAdsResponse[]
}) => {
  const { superAdmin } = useAppInfo()

  return ads?.length ? (
    <Panel
      iconLeft={<VscJson />}
      title="Ads JSON"
      isCollapsible
      initialCollapsibleState={superAdmin}
    >
      <pre
        style={{
          whiteSpace: 'pre-wrap',
          fontFamily: 'monospace'
        }}
      >
        <JsonHighlight data={ads} />
      </pre>
    </Panel>
  ) : (
    <></>
  )
}
